import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { TabComponent } from '../../../components/tab/tab.component';
import { TabLayoutComponent } from '../../../components/tab-layout/tab-layout.component';
import { APITableComponent } from '../../../components/table/api-table/api-table.component';
import { TableRow } from '../../../components/table/table.interface';

@Component({
  selector: 'app-products-tab',
  imports: [TabLayoutComponent, APITableComponent],
  providers: [{ provide: TabComponent, useExisting: ProductsTabComponent }],
  templateUrl: './products-tab.component.html',
  styleUrls: ['./products-tab.component.scss'],
})
export class ProductsTabComponent extends TabComponent {
  override name = this.dictionaryService.get('Products');

  constructor(private router: Router) {
    super();
  }

  public async main(): Promise<void> {}

  onProductRowClick = (row: TableRow) => {
    const productId = row.value['id'] || row.id;
    if (productId) {
      this.router.navigate(['/products', productId]);
    }
  };
}
